var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class News extends Component {
    constructor() {
        super('News', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('.btn-toggle-collapse').on('click', (event, button) => {
                event.preventDefault();
                button.parents('.module-news-content').toggleClass('is-expanded');
            });
            $('.module-news-content').on('click', (event, element) => {
                console.log(element, event.target, $(event.target).hasClass('btn-toggle-collapse'));
                if (element.hasClass('is-expanded') || $(event.target).hasClass('btn-toggle-collapse'))
                    return;
                element.toggleClass('is-expanded');
            });
            $(window).on('resize', () => this.computeMaxHeight());
            this.computeMaxHeight();
            setTimeout(() => this.computeMaxHeight(), 1000);
            this.success();
        });
    }
    computeMaxHeight() {
        $('.module-news-default').each((news) => {
            const maxHeight = $(window).width() < 992 ? 160 : news.find('.image').height() - news.find('.module-news-collapse').position(news.find('.module-news-content')).y;
            news.find('.module-news-collapse').css('--max-height', `${maxHeight}px`);
            if (news.find('.module-news-collapse-content').height() <= maxHeight) {
                news.find('.module-news-collapse').removeClass('has-collapse');
                news.find('.btn-toggle-collapse').addClass('d-none');
            }
            else {
                news.find('.module-news-collapse').addClass('has-collapse').css('--expanded-max-height', `${news.find('.module-news-collapse-content').height()}px`);
                news.find('.btn-toggle-collapse').removeClass('d-none');
            }
        });
    }
}
